module.exports = __webpack_public_path__ + "static/media/chevron-up.454472e7.svg";